import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/menulist',
    name: 'menulist',
    component: () => import('../views/menuList.vue')
  },
  {//网站声明
    path: '/shengming',
    name: 'shengming',
    component: () => import('../views/shengming.vue')
  },
  {//联系我们
    path: '/lianxi',
    name: 'lianxi',
    component: () => import('../views/lianxi.vue')
  },
  {//网站地图
    path: '/ditu',
    name: 'ditu',
    component: () => import('../views/ditu.vue')
  },
  {//手机文章详情分享
    path: '/article',
    name: 'article',
    // meta: {
    //   title: '111',
    // },
    component: () => import('../views/article.vue')
  },
  {
    path: '*',
    name: 'Home',
    component: Home
  }
]

const router = new VueRouter({
  routes,
  mode:'history'
})
// router.beforeEach( (to, from, next)=> {
//   document.title = to.meta.title
//   next()
// }
// )
export default router
